import { render, staticRenderFns } from "./tradeCash.vue?vue&type=template&id=de55f516&scoped=true"
import script from "./tradeCash.vue?vue&type=script&lang=js"
export * from "./tradeCash.vue?vue&type=script&lang=js"
import style0 from "./tradeCash.vue?vue&type=style&index=0&id=de55f516&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__coffee-script@_nvev6wbrwofx6itvk2x4sio6cy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de55f516",
  null
  
)

export default component.exports